var PropTypes = require('prop-types');

export function DeviceType({deviceType}) {
  switch (deviceType) {
    case 'tablet':
      return <span><i className='fa fa-tablet' /> Tablet</span>;
    case 'phone':
      return <span><i className='fa fa-mobile' /> Phone</span>;
    case 'printer':
      return <span><i className='fa fa-print' /> Printer</span>;
    default:
      return <span>${deviceType}</span>;
  }
}

export default function LogMetadata({
  appName,
  deviceIdentifier,
  appVersion,
  make,
  deviceModel,
  osName,
  osApiVersion,
  osVersion,
  sdkVersion
}) {
  return (
    <div className='device'>
      <span>App Name: {appName}</span>
      <span>App Version: {appVersion}</span>,&nbsp;
      <span>SDK Version {sdkVersion}</span>,&nbsp;
      <span>Device: <a href={`/devices/${deviceIdentifier}/`}>{make} {deviceModel}</a></span>,&nbsp;
      <span>OS: {osName ? osName.titleCase(): 'Unknown'} {osVersion}{osApiVersion ? " (API Version: " + osApiVersion + ")": null}</span>,&nbsp;
    </div>
  );
}
